function normalizeBaseUrl(xrhubUrl) {
  const normalized = String(xrhubUrl || "")
    .trim()
    .replace(/\/+$/, "");

  return /^https?:\/\//i.test(normalized) ? normalized : "";
}

function normalizeCreatorBasePath(creatorBasePath) {
  const normalizedBasePath = String(creatorBasePath || "").trim();

  if (!normalizedBasePath || normalizedBasePath === "/") {
    return "";
  }

  return normalizedBasePath.startsWith("/")
    ? normalizedBasePath.replace(/\/+$/, "")
    : `/${normalizedBasePath.replace(/\/+$/, "")}`;
}

function resolveLocationOrigin(locationOrigin) {
  return locationOrigin || "";
}

function stripCreatorBasePath(pathname, creatorBasePath) {
  const normalizedBasePath = normalizeCreatorBasePath(creatorBasePath);

  if (!normalizedBasePath) {
    return pathname;
  }

  if (pathname === normalizedBasePath) {
    return "/";
  }

  const basePathWithSlash = `${normalizedBasePath}/`;

  if (pathname.startsWith(basePathWithSlash)) {
    return pathname.slice(normalizedBasePath.length);
  }

  return pathname;
}

function resolveIncomingPath(path, { creatorBasePath } = {}) {
  const matches = String(path || "/").match(/^([^?#]*)(\?[^#]*)?(#.*)?$/);
  const pathname = stripCreatorBasePath((matches && matches[1]) || "/", creatorBasePath);
  const search = (matches && matches[2]) || "";
  const hash = (matches && matches[3]) || "";

  return `${pathname}${search}${hash}`;
}

export function resolveXrhubBaseUrl(xrhubUrl, { locationOrigin } = {}) {
  const normalizedXrhubUrl = normalizeBaseUrl(xrhubUrl);
  if (normalizedXrhubUrl) {
    return normalizedXrhubUrl;
  }

  const resolvedLocationOrigin = normalizeBaseUrl(resolveLocationOrigin(locationOrigin));
  return resolvedLocationOrigin ? `${resolvedLocationOrigin}/xrhub` : "";
}

export function buildXrhubAppRedirectUrl(path, { xrhubUrl, locationOrigin, creatorBasePath } = {}) {
  const baseUrl = resolveXrhubBaseUrl(xrhubUrl, { locationOrigin });
  const normalizedPath = resolveIncomingPath(path, { creatorBasePath });
  const relativePath = normalizedPath.replace(/^\/+/, "");

  if (!baseUrl) {
    return normalizedPath;
  }

  return new URL(relativePath, `${baseUrl}/`).href;
}

export function buildXrhubLoginRedirectUrl(returnTo, { xrhubUrl, locationOrigin, loginPath = "/login" } = {}) {
  const baseUrl = resolveXrhubBaseUrl(xrhubUrl, { locationOrigin });
  const normalizedLoginPath = String(loginPath || "/login").replace(/^\/+/, "");
  if (!baseUrl) {
    const searchParams = new URLSearchParams();

    if (returnTo) {
      searchParams.set("returnTo", returnTo);
    }

    const query = searchParams.toString();
    return `/xrhub/${normalizedLoginPath}${query ? `?${query}` : ""}`;
  }

  const loginUrl = new URL(normalizedLoginPath, `${baseUrl}/`);

  if (returnTo) {
    loginUrl.searchParams.set("returnTo", returnTo);
  }

  return loginUrl.href;
}
